import * as SSPA from "single-spa";
import {debugf} from "@helpers/string";
import {useLookupsStore, useOrdersStore} from "@store";


window.SSPA = SSPA;

await (async function () {
    let bootingProps = await import('./bootstrap');

    if (bootingProps) {
        let bag = window.SSPA?.bag || {},
            loadApp = window.SSPA?.loadApp || (() => null),
            registered = false;

        for (const app in bag) {
            await window.SSPA.registerApplication(
                `${app}/app`,
                async () => await loadApp(app),
                location => registered && bag[app].check(location),
                bootingProps
            )
        }
        registered = true;

        window.SSPA.start({
            urlRerouteOnly: true,
        });
    }
    function storeLogger({name,
        store, // store instance, same as `someStore`
        args, // array of parameters passed to the action
        after, onError, }) {
          
        const startTime = Date.now()
        console.log(`StoreId:[${store.$id}] Action:[${name}] with params [${args.join(', ')}].`)
    
        after((result) => {
          console.log(`StoreId:[${store.$id}] Finished "${name}" after ${
              Date.now() - startTime
            }ms. Result: ${result}.`
          );
          return result;
        })
    
        // this will trigger if the action throws or returns a promise that rejects
        onError((error) => {
          console.log(
            `StoreId[${store.$id}] FAILED!!! "${name}" after ${Date.now() - startTime}ms.\nError: ${error}.`
          )
        })
      }
    useOrdersStore().$onAction(storeLogger);
    useLookupsStore().$onAction(storeLogger);
})();